export default __webpack_public_path__ + "static/media/industry_introduction_pic.46efedb0.png";